/* Built In Imports */
/* External Imports */
import { Box, Text } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';

/* Internal Imports */
/* Components */
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';

/* Styles */

const CustomizeTitle = ({ sectionContent, pt }) => {
  return (
    <Box maxw={'900px'}>
      <Box
        as="h2"
        pb="15px"
        w={'100%'}
        mx={'0'}
        textAlign={'center !important'}
      >
        <Text fontSize={{ base: '24px', md: '30px', lg: '30px' }}>
          <StructuredTextParser
            className={'h2style'}
            str={render(sectionContent?.body)}
          />
        </Text>
      </Box>

      <style jsx global>
        {`
          .h2style h2 {
            font-family: 'FedraSansStd-A-medium', serif;
            font-size: 30px;
            line-height: 36px;
            text-align: center;
            margin-bottom: 10px;
            margin-top: 20px;
          }
          @media (max-width: 768px) {
            .h2style h2 {
              font-size: 24px;
            }
          }
        `}
      </style>
    </Box>
  );
};

export default CustomizeTitle;
